// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import Element from 'element-ui';
import { Message } from 'element-ui';//消息提示插件
import 'element-ui/lib/theme-chalk/index.css';

// 查看图片
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer);
Viewer.setDefaults({
	Options: {
		"inline": true, "button": true, "navbar": true, "title": true, "toolbar": true,
		"tooltip": true, "movable": true, "zoomable": true, "rotatable": true, "scalable": true,
		"transition": true, "fullscreen": true, "keyboard": true, "url": "data-source"
	}
});

// title显示店名
router.beforeEach((to, from, next) => {
  let shopId = window.localStorage.getItem("shopId");
  if (Number(shopId) > 0) {
    axios.get('/shopService/get?shopId=' + shopId).then((res) => {
      if (res.data.returnCode == 'ok') {
        let result = res.data.result;
        document.title = result.name;
      }
    })
  }
	next();
});

import axios from 'axios'
Vue.prototype.$http = axios;

Vue.prototype.$Message = Message;
Vue.use(Element);

import Vuex from 'vuex'
import store from './vuex/store'
Vue.use(Vuex)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	components: { App },
	template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js